import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var changePswRes;
export const changePswTodo = createAsyncThunk('changePsw', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'update_password',
            data: {
                "vuser_name": localStorage.getItem('vuser_name'),
                "vcurrent_password": data?.current_psw,
                "vnew_password":  data?.new_psw,
                "vclient_code": localStorage.getItem('vcust_plant_code')
            },
            headers: { "Content-Type": "application/json" }
        })
        return changePswRes = res.data

    } catch (error) {
        return changePswRes = error.response.data
    }
})


